export const SLR = 'student-loan-refi'
export const PSL = 'student-loan'
export const PL = 'personal-loan'
export const MORTGAGE = 'mortgage'
export const MORTGAGE_REFI = 'mortgage-refi'
